import { render, staticRenderFns } from "./offsetDetail.vue?vue&type=template&id=c3c28a5c&scoped=true&"
import script from "./offsetDetail.vue?vue&type=script&lang=js&"
export * from "./offsetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c28a5c",
  null
  
)

export default component.exports